import React from 'react';
import './Programs.css';
import { Link } from 'react-router-dom';

export default function ProgramCard({ href, image, title, isExternal=false }) {
    return (
        <Link to={`/programs/${href}`} className="program_card">
            <img src={image} alt={title} className="program_image" />
            <div className="program_title">{title}</div>
        </Link>
    );
}
